<script lang="ts">
  import type { Button } from '$lib/sanity/schemas';
  import BlockButton from '$components/Button/BlockButton.svelte';
  import { getIconByShape } from '$components/News/ButtonShapes';

  interface Props {
    document: Button;
  }

  let { document }: Props = $props();
</script>

<BlockButton href={document.link.url} motion="never">
  {document.link.text}
  {#snippet icon()}
    {@const SvelteComponent = getIconByShape(document.shape)}
    <SvelteComponent />
  {/snippet}
</BlockButton>
